import { render, staticRenderFns } from "./PolestarResult.vue?vue&type=template&id=a95ae3ca&"
import script from "./PolestarResult.vue?vue&type=script&lang=js&"
export * from "./PolestarResult.vue?vue&type=script&lang=js&"
import style0 from "./PolestarResult.vue?vue&type=style&index=0&id=a95ae3ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports